'use client';
import Checkmark from '@svenskaspelab/ui/react/icons/Checkmark';
import Close from '@svenskaspelab/ui/react/icons/Close';
import type { ReactNode } from 'react';

/**
 * Renders an icon indicating whether the outcome of a coupon event is correct or incorrect.
 *
 * @param root0 props for component
 * @param root0.isCorrectOutcome indicates if the outcome is correct
 * @returns A ReactNode that displays whether the outcome is correct or incorrect.
 */
export function CouponInitIcon({ isCorrectOutcome }: { isCorrectOutcome: boolean | undefined }): ReactNode {
  if (isCorrectOutcome === undefined) {
    return undefined;
  }
  return (
    <div className={isCorrectOutcome ? 'text-success' : 'text-important'}>
      {isCorrectOutcome ? <Checkmark /> : <Close />}
    </div>
  );
}
